import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useCookies } from 'react-cookie';
import { addHours } from 'date-fns';
import useScrollPosition from '../hooks/useScrollPosition';
import canUseDom from '../../util/canUseDOM';
import metrics from '../../browser/metrics';
import CommentBox from './CommentBox';
import VoteButtons from './VoteButtons';

import styles from './styles.module.styl';

/* eslint-disable jsx-a11y/no-static-element-interactions */
const FeedbackWidget = ({ topbar, variant }) => {
  const [widgetVisible, setWidgetVisible] = useState(false);
  const [vote, setVote] = useState(null);
  const [done, setDone] = useState(null);
  const [cookies, setCookie] = useCookies();
  const scrollPos = useScrollPosition();

  if (!canUseDom()) { return <></>; }
  if (done) { return <></>; }

  // Feedback widget has been dismissed wait to show until expiration
  if (cookies.dismissFeedbackWidget && new Date().getTime() < cookies.dismissFeedbackWidget) {
    return <></>;
  }

  // Variant Partial will only display when scrolled 70%
  if (!vote && variant.indexOf('Partial') > -1) {
    const amountScrolled = (window.innerHeight + scrollPos.y) / document.body.scrollHeight;

    if (amountScrolled > 0.40) {
      if (!widgetVisible) setWidgetVisible(true);
    } else if (widgetVisible) {
      setWidgetVisible(false);
    }
  } else if (!widgetVisible) {
    setWidgetVisible(true);
  }

  const submitComment = (comment) => {
    setDone(true);
    metrics.track('feedback:submit-comment', { value: vote === 'positive', trackData: comment, track_data2: variant });

    $.post('/docs/submit-feedback', {
      page_title: document.title,
      page_url: window.location.href,
      positive: vote === 'positive',
      comment
    });
  };

  const submitVote = (v) => {
    setVote(v);
    metrics.track('feedback:submit', { value: v === 'positive', track_data2: variant });
  };

  const dismissWidgetFor3Hours = () => setCookie('dismissFeedbackWidget', addHours(new Date(), 3).getTime());

  return (
    <div
      className={cx(
        vote ? styles.feedbackSent : '',
        widgetVisible ? styles.visible : styles.hidden,
        topbar ? styles.topbar : styles.sidebar
      )}
    >
      <a className={topbar ? styles.hidden : styles.closeButton} onClick={dismissWidgetFor3Hours}><i className="icon-budicon-471" /></a>

      {vote && topbar && <CommentBox vote={vote} submit={submitComment} />}

      <h5>{vote ? 'Thanks for the feedback!' : 'Is this article helpful?'}</h5>
      <VoteButtons vote={vote} submit={submitVote} />

      {vote && !topbar && <CommentBox vote={vote} submit={submitComment} />}
    </div>
  );
};

FeedbackWidget.propTypes = {
  topbar: PropTypes.bool,
  variant: PropTypes.string
};

export default FeedbackWidget;
